/**
 * Converts an ISO string into a custom Date Variable object.
 * ISO dates formatted like: '2022-10-25T12:35:20'
 * Are converted to { year: '2022', month: '10', day: '25', hour: '12', minute: '35', second: '20'}
 * @param string
 * @returns datevars: { year: string, month: string, day: string, hour: string, minute: string, second: string }
 */
export const getDateVarsObject = (datetime) => {
  const date = new Date(datetime)

  let year = date.getFullYear().toString()
  let month = (date.getMonth() + 1).toString().padStart(2, "0") // Months are 0-indexed in JavaScript
  let day = date.getDate().toString().padStart(2, "0")
  let hour = date.getHours().toString().padStart(2, "0")
  let minute = date.getMinutes().toString().padStart(2, "0")
  let second = date.getSeconds().toString().padStart(2, "0")

  if (datetime.includes("Z")) {
    if (hour === "23") {
      hour = "00"
      day = (parseInt(day) + 1).toString().padStart(2, "0")
      console.log("Timezoneshift dateskip detected.")
    } else {
      hour = (parseInt(hour) + 1).toString().padStart(2, "0")
    }
    second = "00"
  }

  return {
    year,
    month,
    day,
    hour,
    minute,
    second,
  }
}

/**
 * Turns a number value e.g. '12' into a readable month abbreviation like 'Dec' for December.
 * culture is 'da' by default, set 'en' for english month abbreviations.
 * @param {*} monthVar
 * @param {*} culture
 * @returns string
 */
export const getRealMonth = (monthVar, culture = "da") => {
  const monthsEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  const monthsDa = ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"]

  let index = parseInt(monthVar, 10) - 1 // monthVar is 1-indexed, but arrays are 0-indexed

  // Ensure the index is within 0-11 also for negative indexes
  index = ((index % 12) + 12) % 12

  return culture === "en" ? monthsEn[index] : monthsDa[index]
}

export const formatOpeningHours = (time, lang) => {
  if (time) {
    var timeSplit = time.split(":")
    var date = new Date()
    date.setHours(timeSplit[0], timeSplit[1], timeSplit[2])
    //always formatting to danish time so we have a 24-hour format without AM/PM
    //above comment is obsolete as of PAR-2912, adding 12-hour format for english view.
    if (lang === "da") {
      return date
        .toLocaleTimeString("da", {
          hour: "2-digit",
          minute: "2-digit",
        })
        .replace(".", ":")
    }
    if (lang === "en" && date.getMinutes() !== 0) {
      let displayTime = date
        .toLocaleTimeString("en", {
          timeStyle: "short",
        })
        .replace(".", ":")

      return displayTime.toLocaleLowerCase()
    } else if (lang === "en" && date.getMinutes() === 0) {
      let displayHours = timeSplit[0]
      let suffix = displayHours >= 12 ? "pm" : "am"
      displayHours = displayHours % 12 || 12
      let displayTime = `${displayHours} ${suffix}`

      return displayTime
    }
  }
  return ""
}

function isBetween(number, min, max) {
  return number >= min && number <= max
}

// example inputs are
// "04:30", "22:00", "da"
// "4:30 am", "10 pm", "en"

export const isMerchantOpen = (openingTimeStr, closingTimeStr, lang) => {
  const now = new Date()
  const currentHour = now.getHours()
  const currentMinute = now.getMinutes()
  const currentMinutes = currentHour * 60 + currentMinute

  // Function to convert time string to hours and minutes
  const convertTimeStringToHoursAndMinutes = (timeStr, lang) => {
    const date = new Date()
    let hours
    const [hoursMinutes, amPmPart = ""] = timeStr.split(" ")
    const [hoursString, minutesString = "00"] = hoursMinutes.split(":")
    if (lang === "en") {
      hours = parseInt(hoursString, 10) % 12
      if (amPmPart.toLowerCase() === "pm") hours += 12
    } else {
      hours = parseInt(hoursString, 10) % 24
    }
    const minutes = parseInt(minutesString, 10) % 60
    date.setHours(hours, minutes)
    return date.getHours() * 60 + date.getMinutes()
  }

  // Convert opening and closing times to minutes for easier comparison
  const openingMinutes = convertTimeStringToHoursAndMinutes(openingTimeStr, lang)
  const closingMinutes = convertTimeStringToHoursAndMinutes(closingTimeStr, lang)

  // Check if current time falls within opening hours
  return currentMinutes >= openingMinutes && currentMinutes <= closingMinutes
}
